import slugify from 'slugify'

export const sanitizeString = string => {
  if (!string) return null
  return slugify(string, {
    lower: true,
    remove: /[*+~.,()'"!:;/@]/g,
    locale: 'de'
  })
}
